var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCupIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -62.2254,
    y: -24.7487,
    width: 553.665,
    height: 461.034
  }), /*#__PURE__*/React.createElement("rect", {
    x: -69.2965,
    y: 18.3848,
    width: 529.623,
    height: 422.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.72,
    y: 3.53553,
    width: 8.48528,
    height: 12.0208
  }), /*#__PURE__*/React.createElement("rect", {
    x: -88.3884,
    y: -22.6274,
    width: 497.096,
    height: 424.264
  }), /*#__PURE__*/React.createElement("rect", {
    x: -74.9533,
    y: -36.7696,
    width: 518.309,
    height: 437.699
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-19.799-19.799v431.82h453.74v-424.532z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.81 232.539h100.38",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2068",
    d: "m149.81 232.539c-26.8043-19.8783-44.2712-58.058-49.1833-127.242",
    fill: "none"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 400 0)",
    width: "100%",
    height: "100%",
    xlinkHref: "#path2068"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.994 129.228c106.001-19.6005 3.24319 80.2431-29.1642 83.4927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.627 105.296h198.746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6156",
    d: "m200 240.775c-13.3593 48.4763-21.0944 76.0104 1.3e-4 78.2842",
    fill: "none"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 400 -9.48292e-7)",
    width: "100%",
    height: "100%",
    xlinkHref: "#path6156"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#caba9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m195.814 317.399c-3.34243-1.18122-5.87527-4.12072-7.14084-8.28734-0.94949-3.12599-1.03297-4.27137-0.76957-10.5588 0.41315-9.86225 2.41159-19.2401 10.6347-49.9042l1.43516-5.35171 1.88268 6.85171c7.05433 25.6731 9.88143 39.0825 10.2598 48.6642 0.23693 5.99964 0.14232 7.22968-0.79295 10.3088-2.21067 7.27815-8.63468 10.7067-15.509 8.27734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.851 206.125c-49.8705 13.3628 7.49706-12.9443 22.0629-23.875 44.2686-33.2206 38.6091-58.4578 2.32106-48.7344-3.75307 1.00563 1.29083-7.12688 1.57253-7.30098 15.16-2.13153 49.2239-7.55704 44.9783 14.468-2.56028 12.0663-16.5335 30.2676-40.0356 48.6321-9.82399 7.6765-21.3225 14.5483-28.4533 17.0043-3.36404 1.15866-0.89242-0.61018-2.44593-0.19392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.226 227.567c-20.9555-18.3116-34.2937-49.08-40.6802-93.8409-1.32246-9.2686-2.79577-22.8284-2.79577-25.7312v-1.74544h196.5v1.74544c0 5.63513-3.10535 29.6272-5.30429 40.9812-7.08715 36.5936-20.2324 63.414-38.7923 79.1484l-4.27597 3.625-99.8774-0.01-4.77401-4.17169z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon5);
export default __webpack_public_path__ + "static/media/cupIcon5.0f3e505e73116d2b833ac2f64264e91b.svg";
export { ForwardRef as ReactComponent };